import type { MouseEvent } from "react";
import { playClick } from "./sounds";

export function blockRowNavProps(onClick: () => void) {
  return {
    onMouseDown: (e: MouseEvent) => {
      if (e.button !== 0) return;
      e.stopPropagation();
      e.preventDefault();
      playClick();
      onClick();
    },
    onClick: (e: MouseEvent) => {
      e.stopPropagation();
      e.preventDefault();
    },
  };
}
